import { Investigation, InvestigationStatus } from '@/types';

// Returns the deadline that's currently in effect for a given investigation,
// based on which SLA stage it sits in. Returns null when no SLA applies
// (completed, cancelled, or a status without a tracked deadline).
export function activeSlaDeadline(inv: Pick<
  Investigation,
  'status' | 'assignmentDeadline' | 'fieldworkDeadline' | 'reviewDeadline'
>): string | null {
  switch (inv.status) {
    case InvestigationStatus.AWAITING_APPROVAL:
      return inv.assignmentDeadline ?? null;
    case InvestigationStatus.IN_PROGRESS:
      return inv.fieldworkDeadline ?? null;
    case InvestigationStatus.UNDER_REVIEW:
      return inv.reviewDeadline ?? null;
    default:
      return null;
  }
}
